<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>افزودن بلاگ جدید</h1>
          <hr class="mb-3" />
          <b-row>
            <b-col cols="12">
              <b-form @submit.prevent>
                <b-form-group label="عنوان بلاگ" label-for="title">
                  <b-form-input
                    id="title"
                    v-model="blogDetails.title"
                    trim
                    placeholder="عنوان بلاگ را وارد کنید"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-form @submit.prevent>
                <b-form-group label="زمان مطالعه" label-for="title">
                  <b-form-input
                      id="title"
                      v-model="blogDetails.spendTimeForRead"
                      trim
                      placeholder="10 دقیقه"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-form @submit.prevent>
                <b-form-group label="وضعیت انتشار بلاگ" label-for="blogStatus">
                  <b-form-select
                    id="blogStatus"
                    v-model="blogDetails.status"
                    :options="blogStatusEnums"
                  ></b-form-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <blog-category-picker
                @getBlogCategory="setBlogCategory"
              ></blog-category-picker>
            </b-col>
            <b-col cols="12">
              <b-form @submit.prevent>
                <b-form-group label="خلاصه بلاگ" label-for="summary">
                  <b-form-textarea
                    placeholder="آموزش زبان انگلیسی به شکل سنتی..."
                    id="summary"
                    v-model="blogDetails.shortDescription"
                  ></b-form-textarea>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12">
              <small>محتوای بلاگ</small>
              <quillEditor
                class="mt-1"
                v-model="blogDetails.content"
                :options="editorOption"
              />
            </b-col>
            <b-col cols="12" class="mt-3">
              <Uploader
                  ref="imageUrl"
                  @getFiles="setFile" label="تصویر شاخص بلاگ"
                  :file-type="6"></Uploader>
            </b-col>

            <b-col class="mt-3" cols="12">
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  type="button"
                  variant="success"
                  @click="sendBlogCreateRequest"
                >
                  ایجاد بلاگ
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import BlogCategoryPicker from "@/views/components/Blog/BlogCategoryPicker.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {quillEditor} from "vue-quill-editor";
import {CreateABlog} from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BPagination,
  BRow,
} from "bootstrap-vue";
import FileUploader from "@/views/components/Utils/CustomUploadMedia.vue";
import Uploader from "@/views/components/Uploader.vue";

export default {
  data() {
    return {
      isLoading: false,
      blogValidations: ['title', 'content','blogCategoryId'],
      blogDetails: {
        blogCategoryId: null,
        title: "",
        spendTimeForRead: "",
        type: "Blog",
        tableOfContent: "",
        content: "",
        shortDescription: "",
        secretKey: "",
        status: "Publish",
        mainImageFile: ""
      },
      blogImage: null,
      blogStatusEnums: [
        {
          text: "انتشار",
          value: 'Publish',
        },
        {
          text: "آرشیو",
          value: 'PreRelease',
        },
      ],
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  methods: {
    setFile(medias) {
      if (medias.length) {
        this.blogDetails.mainImageFile = medias[0];
      }
    },
    async sendBlogCreateRequest() {
      let isValid = true
      for (let i = 0; i < this.blogValidations.length; i++) {
        if (!this.blogDetails[this.blogValidations[i]]) {
          isValid = false;
        }
      }
      if (isValid) {
        try {
          this.isLoading = true;
          let _this = this;
          let createABlog = new CreateABlog(_this);
          _this.blogDetails.secretKey = this.fermanSecretKey
          _this.$refs.imageUrl.getFiles()
          createABlog.setRequestParamDataObj(_this.blogDetails);
          await createABlog.fetch((response) => {
            if (response.isSuccess) {
              _this.blogDetails = {
                blogCategoryId: null,
                title: "",
                spendTimeForRead: "",
                type: "Blog",
                tableOfContent: "",
                content: "",
                shortDescription: "",
                secretKey: "",
                status: "Publish",
                mainImageFile: ""
              };
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "بلاگ با موفقیت ایجاد شد",
                  icon: "BookOpenIcon",
                  variant: "success",
                },
              });
              _this.$router.push('/blogs')
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: response.errorMessage || "لطفا دوباره تلاش کنید",
                },
              });
            }
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "مشکلی پیش آمد!",
            icon: "XIcon",
            variant: "danger",
            text: 'لطفا فیلدهای اجباری را پر کنید',
          },
        });
      }
    },
    setBlogCategory(categoryId) {
      this.blogDetails.blogCategoryId = categoryId;
    },
  },
  computed: {
    fermanSecretKey() {
      return process.env.VUE_APP_BLOG_SECRET
    },
    imagePreview() {
      if (this.blogImage) {
        return URL.createObjectURL(this.blogImage);
      }
    },
  },
  components: {
    Uploader,
    FileUploader,
    BlogCategoryPicker,
    quillEditor,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormFile,
    BFormSelect,
    BFormTextarea,
    BButton,
    BPagination,
    BOverlay,
  },
};
</script>
